import AUMSAppConfig from './AUMS/AUMSAppConfig';

const CustomConfigs = [AUMSAppConfig];

export default CustomConfigs;
